import { PlinkoGame } from "../Games/Plinko/PlinkoGame";

export default function PlinkoPage() {
  return (
    <PlinkoGame />
  );
}
